// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8Ewf9pi-rgM32PU4zN6KgNqyN5XC-Izc",
  authDomain: "bsf-teams.firebaseapp.com",
  projectId: "bsf-teams",
  storageBucket: "bsf-teams.firebasestorage.app",
  messagingSenderId: "351400451327",
  appId: "1:351400451327:web:9d102827b61895679e80ca"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = (cb=null) => {
    // The method getToken(): Promise<string> allows FCM to use the VAPID key credential
    // when sending message requests to different push services
    return getToken(messaging, { vapidKey: `BL2Ge7DmlDweMDxHtTkBS4uZm0DCtVWxipFHOwQdySXT3RqMF-3PVuEUY_Y7fiNqrkcPOxPYkhFhJlIcQRCyvtI` }) //to authorize send requests to supported web push services
        .then((currentToken) => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);

                if(localStorage.getItem('fcmToken') && currentToken !==localStorage.getItem('fcmToken')){
                    localStorage.setItem('fcmToken', currentToken);

                }

                else if(!localStorage.getItem('fcmToken')){
                    localStorage.setItem('fcmToken', currentToken);

                }

                if(cb){
                    cb(currentToken);
                }
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }
        })
        .catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });
};